import {createOcapiFetch} from './utils'

class OcapiShopperOrder {
    constructor(config) {
        this.fetch = createOcapiFetch(config)
    }

    /**
     * Calls the built-in api for the host-name and then the ocapi call for site, fetching
     * available payment- and shipping methods not included in the first call
     */
    async getOrderNumber(...args) {
        var orderResult = await this.fetch(
            `custom_objects/ocapi/order?token=${args[0].orderToken}`,
            'GET',
            args,
            'getOrderNumber'
        )

        return {
            orderNumber: orderResult.c_result.orderNo
        }
    }

    /**
     * Calls the server in order to check if the basket is valid.
     */
    async isBasketValid(...args) {
        var orderResult = await this.fetch(
            `custom_objects/ocapi/basket`,
            'GET',
            args,
            'isBasketValid'
        )

        return {
            isValid: orderResult?.c_result?.valid,
            errorMessage: orderResult?.c_result?.errorMessage
        }
    }
}

export default OcapiShopperOrder
